import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { FormField } from '../../../../../../../../../global/form/form-field/form-field';
import { RichTextEditor } from '../../../../../../../../../global/rich-text-editor';
import { InfoPopover } from '../../../../../../../../../global/info-popover/info-popover';
import { DefaultPageViewModel } from '../../../default-page.viewmodel';
import { useReplaysNotes } from './replays-notes.hook';

type IProps = {
    pageVm: DefaultPageViewModel;
};

export const ReplaysNotesField = observer(({ pageVm }: IProps): JSX.Element => {
    const {
        replaysNotes,
        replaysNotesEntity,
        replaysNotesLabelText,
        handleReplaysNotesChange,
        handleReplaysNotesBlur
    } = useReplaysNotes(pageVm);

    return (
        <FormField label={
            <div className='flex m-bottom-6px'>
                {replaysNotesLabelText}
                <InfoPopover className='m-left-8px'>
                    {replaysNotesEntity.toggleInfoMessage}
                </InfoPopover>
            </div>
        }>
            <div className='flex'>
                <RichTextEditor
                    className='oe-form-field__control p-0px m-0px'
                    value={replaysNotes.value as string || ''}
                    onChange={handleReplaysNotesChange}
                    onBlur={handleReplaysNotesBlur}
                    dataTestId='replays-notes-rich-text-editor'
                />
            </div>
            <span className='oe-form-field__error'>
                {!replaysNotes.valid && replaysNotes.touched && (
                    <FormattedMessage values={{ fieldName: replaysNotesLabelText }} {...replaysNotes.validationMessage} />
                )}
            </span>
        </FormField>
    );
});